import React from "react";
import PropTypes from "prop-types";

class VendorTagFilter extends React.Component {
    static defaultProps = {
        tags:[],
    };

    static propTypes = {
        tags: PropTypes.string
    };
    state = {
        tags: [],
        tag: 0
    };
    handleInputChange = (e) => {
        if(e.target.value === "all") {
            window.location = "/vendors";
        } else {
            window.location = "/vendors/"+e.target.value;
        }
    }
    setInitialState = (tag, tags) => {
        this.setState({tag});
        this.setState({tags});
    }
    componentDidMount() {
        let storedTags = this.props.tags.replace(/['"[\]]+/g, "").split(",");

        // storedTags = storedTags.split(",");
        let location = window.location.pathname;

        let test = location.split("/vendors/");

        let tag = "";

        if(test.length > 1){
            tag = test[1].replace(/\//, "");
        }

        let tags = ["All"];

        for(let i = 0; i<storedTags.length; i++){
            tags.push(storedTags[i]);
        }
        this.setInitialState(tag, tags);
    }
    componentWillUnmount() {
        this.setInitialState = () => {};
    }
    render() {
        return (
            <div className="MagazineFilter">
                <select name="tag" value={this.state.tag} onChange={this.handleInputChange}>
                    {this.state.tags.map((item, index) => {
                        return (
                            <option key={index} value={item.toLowerCase().trim().replace(/[ ]+/g, "-")}>{item}</option>
                        );
                    })}
                </select>
            </div>
        );
    }
}

export default VendorTagFilter;
